<template lang="pug">
  div.individuals
    e-toolbar(
    :items="items"
    @deleteItems="deleteItems"
    :hideRemoveButton="true"
    :showTotal="true"
    :showViewPanel="false"
    :hideImportBtn="true"

    :useFilterBtn="true"
    :showFilter="showFilter"
    @closeFilterPanel="onCloseFilterPanel()"
    @openFilterPanel="onOpenFilterPanel()"
    )
      e-form-search-filter(
      slot="filter"
      :formValidator="formValidator"
      v-if="showFilter"
      @apply="applyFilter()"
      @reset="resetFilter()"
      )
        div.filter-cols
          div.filter-col
            div.one-row
              e-form-group(
              formGroupStyle="filter-block"
              label="Дата рождения"
              inputType="calendar-range"
              :model="filterModel"
              tabView="tab1"
              name="bday_from"
              toName="bday_to"
              )
              e-form-group(
              formGroupStyle="filter-block"
              label="СНИЛС"
              :model="filterModel"
              tabView="tab1"
              name="snils"
              )
              e-form-group(
              formGroupStyle="filter-block"
              label="Дата последнего изменения"
              inputType="calendar-range"
              :model="filterModel"
              tabView="tab1"
              name="last_update_from"
              toName="last_update_to"
              )
            div.vertical-delimiter
              div.filter-block
                label {{$translate('Документ, удостоверяющий личность')}}

            div.one-row
              e-form-group(
              formGroupStyle="filter-block"
              label="Вид"
              :model="filterModel"
              tabView="tab1"
              name="identity_card_type_id"
              inputType="select"
              :options="identityCardTypes"
              :disablePlaceholderOption="false"
              placeholder="Любой"
              )
              e-form-group(
              formGroupStyle="filter-block"
              label="Номер"
              :model="filterModel"
              tabView="tab1"
              name="identity_card_number"
              )
              e-form-group(
              formGroupStyle="filter-block"
              label="Серия"
              :model="filterModel"
              tabView="tab1"
              name="identity_card_series"
              )
              e-form-group(
              formGroupStyle="filter-block"
              label="Дата"
              :model="filterModel"
              tabView="tab1"
              inputType="calendar"
              name="identity_card_issue_date"
              )

          div.filter-col
            div.one-row
              e-form-group(
              formGroupStyle="filter-block"
              label="Лицевой счет"
              :model="filterModel"
              tabView="tab1"
              name="account_numbers"
              validationRule="number"
              inputType="tags"
              )
          div.filter-col
            div.one-row
              e-form-search-filter-buttons(
              :loading="searchInProgress"
              ).filter-block.is-hidden
            div.vertical-delimiter
              div.filter-block
                label
            div.one-row
              e-form-search-filter-buttons(
              :loading="searchInProgress"
              ).filter-block

    e-table(
    :items="items"
    @deleteItem="deleteItem"
    @editItem="editItem"
    :showCheckbox="false"
    :defaultColumnWidth="120"
    )

    router-view
</template>

<script>
  import {individuals, core} from '../../api/api-endpoints.js'
  import tableMixin from "../../components/table/table-mixin.js"

  const FilterModel = () => ({
    bday_from: '',
    bday_to: '',
    identity_card_type_id: '',
    identity_card_issue_date: '',
    identity_card_number: '',
    identity_card_series: '',
    account_numbers: [],
    last_update_from: '',
    last_update_to: ''
  })

  export default {
    mixins: [tableMixin],
    data () {
      return {
        filterModel: new FilterModel()
      }
    },
    computed: {
      collections () {
        return this.$store.getters.readUrlEndpoint(
          this.getCollectionEndpoint()
        ) || {}
      },
      identityCardTypes () {
        return this.collections.identity_card_type
      }
    },
    methods: {
      getEndpoint (route) {
        // return 'http://localhost:3111/422-data-error'
        return individuals.individuals(route)
      },
      getDeleteUrl (id) {
        return individuals.individualDelete(id)
      },
      getCollectionEndpoint () {
        return core.collection('identity_card_type')
      }
    },
    asyncData ({store, route, fromRoute, methods}) {
      return Promise.all([
        tableMixin.asyncData({store, route, fromRoute, methods}),
        store.dispatch('updateUrlEndpoint', {
          endpoint: methods.getCollectionEndpoint(),
          fromCache: true
        })
      ])
    }
  }
</script>
